import React from "react";

// React 19 hoists <title> and <meta> rendered anywhere into <head>.
export default function Seo({ title, description, canonical, schema }) {
  // La base canonique suit toujours le domaine réellement servi (preview, emergent.host, ou fuitex.fr plus tard).
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = canonical ? `${origin}${canonical}` : origin || undefined;
  return (
    <>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content="index, follow" />
      {url && <link rel="canonical" href={url} />}
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      {url && <meta property="og:url" content={url} />}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </>
  );
}
